<template>
<div>
    <div class="mb-3">
      <a-input v-model="search_query" placeholder="Zoeken">
      <a-icon slot="suffix" type="search" />
      </a-input>
    </div>
    <div v-if="organizationsLoading"  class="w-100 d-flex justify-content-center align-items-center">
          <a-spin size="large" />
    </div>
    <div v-else>
      <div class="w-100 mb-3 d-flex justify-content-end align-items-center">
        <a-checkbox v-model="hideOrgsWithoutDeps">
          Verberg organisaties zonder afdelingen
        </a-checkbox>
        <add-organization :fetchOrganizations="()=>{this.getOrganizations()}" />
        <organization-modal :fetchOrganizations="()=>{this.getOrganizations()}" ref="editOrganizationModal" />
        <department-modal :fetchOrganizations="()=>{this.getOrganizations()}" ref="editDepartmentModal" />
      </div>
        <a-table :columns="organizationColumns" :pagination="false" :data-source="organizations">
            <p class="mb-0" slot="departmentCount" slot-scope="data" >
                {{data.departments.length}}
            </p>
            <p class="mb-0" slot="openInvoicesCount" slot-scope="data" >
                {{data.invoices.length}}
            </p>
            <div slot="action" slot-scope="data">
                <a-button type="primary" class="mr-3" icon="setting" @click="editOrganization(data)" size="" />
                <a-button type="primary" class="mr-3" @click="$router.push({ name: 'singleOrganization', params: { organization_id: data.id } })" icon="profile" size="" />
            </div>
            <div slot="expandedRowRender" slot-scope="data" style="margin: 0">
              
            <div class="d-flex">
              <div>
                <p class="mb-0">{{ data.name }}</p>
                <p class="mb-0">{{ `${data.streetname_housenumber} ${data.zipcode},` }}</p>
                <p class="mb-0">{{ `${data.city}` }}</p>
                <p class="mb-3">{{ data.coc_number }}</p>
              </div>
              <div v-if="data.hasOwnProperty('contact')" class="contact_person_card ml-5">
                <div class="mb-2">
                  <h5>Hoofdcontactpersoon</h5>
                </div>
                <div class="contact_person__card-content " style="">
                <div class="">
                  <div class="mb-0">
                  <h5 class="mb-0">Naam</h5>
                  <p class="mb-2">
                    {{data.contact.first_name}} {{data.contact.last_name}}
                  </p>
                </div>
                <div class="mb-0">
                  <h5 class="mb-0">E-mail</h5>
                  <p class="mb-0">
                    {{data.contact.email}}
                  </p>
                </div>
                </div>
                <div class="ml-5" >
                  <div class="mb-0">
                  <h5 class="mb-0">Telefoonnummer</h5>
                  <p class="mb-0">
                    {{data.contact.phone_number}}
                  </p>
                </div>
                </div>
              </div>
              </div>
            </div>
            <div class="mb-3 d-flex justify-content-end" v-if="data.departments_enabled">
                <add-department :organizationId="data.id" :fetchOrganizations="()=>{getOrganizations()}" />
              </div>
            <div v-if="data.departments.length > 0 && data.departments_enabled" class="mt-3">
              
                <a-table :columns="departmentColumns" :data-source="data.departments">
                <p slot="userCount" slot-scope="departmentdata" >
                    {{departmentdata.users.length}}
                </p>
                <p class="mb-0" slot="openInvoicesCount" slot-scope="data" >
                  {{data.invoices.length}}
                </p>
                <div slot="action" slot-scope="departmentdata">
                  <a-button type="primary" class="mr-3" icon="setting" @click="editDepartment(departmentdata)" size="" />
                </div>
                </a-table>
            </div>
            </div>
        </a-table>
    </div>
</div>
</template>
<script>
import AddDepartment from '../Departments/AddDepartment.vue'
import DepartmentModal from '../Departments/DepartmentModal.vue'
import AddOrganization from './AddOrganization.vue'
import OrganizationModal from './OrganizationModal.vue'

const organizationColumns = [
  { title: 'Name', dataIndex: 'name', key: 'name' },
  { title: 'Aantal afdelingen', key: 'id', scopedSlots: { customRender: 'departmentCount' } },
  { title: 'Openstaande facturen', key: 'id', scopedSlots: { customRender: 'openInvoicesCount' } },
  //   { title: 'Age', dataIndex: 'age', key: 'age' },
  //   { title: 'Address', dataIndex: 'address', key: 'address' },
  { title: 'Action',
    dataIndex: '',
    key: 'id',
    scopedSlots: { customRender: 'action' } },
]
const departmentColumns = [
  { title: 'Name', dataIndex: 'name', key: 'name' },
  { title: 'Aantal gebruikers', key: 'id', scopedSlots: { customRender: 'userCount' } },
  { title: 'Openstaande facturen', key: 'id', scopedSlots: { customRender: 'openInvoicesCount' } },
  //   { title: 'Age', dataIndex: 'age', key: 'age' },
  //   { title: 'Address', dataIndex: 'address', key: 'address' },
  { title: 'Action',
    dataIndex: '',
    key: 'x',
    fixed: 'right',
    scopedSlots: { customRender: 'action' } },
]
export default {
  components: {
    AddOrganization,
    OrganizationModal,
    DepartmentModal,
    AddDepartment
  },
  computed: {
    user: {
      get: function () {
        return this.$store.state.user
      },
    },
  },
  watch: {
    search_query: function(newVal) {
      this.getOrganizations()
    },
    hideOrgsWithoutDeps: function() {
      this.getOrganizations()
    },
  },
  data() {
    return {
      search_query: undefined,
      organizations: [],
      organizationColumns,
      departmentColumns,
      organizationsLoading: true,
      hideOrgsWithoutDeps: false,
    }
  },
  mounted() {
    this.getOrganizations()
  },
  methods: {
    editOrganization(organizationInformation){
      this.$refs.editOrganizationModal.openModal(JSON.parse(JSON.stringify(organizationInformation)));
    },
    editDepartment(departmentInformation){
      this.$refs.editDepartmentModal.openModal(undefined, JSON.parse(JSON.stringify(departmentInformation)));
    },
    getOrganizations() {
      this.organizationsLoading = true
      this.$axios.get('/organization/list', {
        params: {
          search_query: (this.search_query !== undefined || this.search_query !== '') ? this.search_query : null,
          hideOrgsWithoutDeps: this.hideOrgsWithoutDeps,
        },
        headers: {
          'Authorization': `Bearer ${this.user.user.token}`,
        } }).then(response => {
        this.organizationsLoading = false
        this.organizations = response.data
      })
    },
  },
}
</script>
<style lang="scss">
@import url('https://fonts.googleapis.com/css2?family=Open+Sans:wght@700&display=swap');


.contact_person_card {
  display: flex;
  flex-direction: column;
  padding: 16px;
  background-color: lighten(#30336b, 6%);
  color: white;
  border-radius: 8px;
  h5{
    display: flex;
    color: white;
    margin-bottom: 0px;
    font-family: 'Open Sans', sans-serif;
    font-weight: 700;
    text-transform: uppercase;
    font-size: 10px;
  }
  .contact_person__card-content{
    padding: 0 8px;
    display: flex;
  color: white;
  h5{
    display: flex;
    color: white;
    margin-bottom: 0px;
    font-family: 'Open Sans', sans-serif;
    font-weight: 700;
    text-transform: uppercase;
    font-size: 10px;
  }
  }
  
}
</style>